const FacilidadesHome = () => import(/* webpackChunkName: "group-pabx-config" */ '../_views/FacilidadesHome')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'facilidades',
    component: FacilidadesHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Facilidades',
  },
]
